export const Image = ({ src, width, height, className }) => {
  return <img src={src} alt="img" style={{ width, height }} className={className} />;
};
